import React, { HTMLAttributes, ReactElement } from 'react'
import { twMerge } from 'tailwind-merge'

import gopayPayLaterLogoSVG from 'assets/images/gopaylater-logo.svg'
import gopayLogo from 'assets/images/gopay-logo.svg'

const INSTRUMENT_TYPE_LOGO_MAP: Record<InstrumentTypes, string> = {
    GOPAY_WALLET: gopayLogo,
    PAY_LATER: gopayPayLaterLogoSVG,
    GO_CICIL_MAB: gopayPayLaterLogoSVG,
    GOPAY_SAVINGS: gopayLogo,
    JAGO: gopayLogo,
    LINKAJA: gopayLogo,
    BRI: gopayLogo,
    BCA_BLU: gopayLogo,
}

interface HeaderProps extends HTMLAttributes<HTMLElement> {
    readonly instrumentType?: InstrumentTypes
    readonly border?: boolean
    readonly className?: string
}

function Header({
    border,
    instrumentType,
    className,
    ...props
}: HeaderProps): ReactElement {
    const resolvedInstrumentType = instrumentType ?? 'GOPAY_WALLET'
    const logo = INSTRUMENT_TYPE_LOGO_MAP[resolvedInstrumentType]

    return (
        <div
            data-testid="header"
            {...props}
            className={twMerge(
                'flex flex-row items-center h-14 py-4 px-5',
                border ? 'border-b border-neutral-300' : '',
                className
            )}
        >
            <img
                src={logo}
                alt={`logo-${resolvedInstrumentType.toLowerCase()}`}
                height="24px"
                data-testid="header-logo"
            />
        </div>
    )
}

export default Header
